<template>
	<valuation-layout>
		<valuation-model-stepper slot="stepper" :current-step="1" />
		<valuation-model-factor-list
			:factor-list="factorList"
			:selected-factors="selectedFactors"
			@factorSelected="onFactorClick"
			slot="content"
		/>
		<valuation-model-description-navigation
			slot="description"
			:next-is-enabled="hasValidFactors"
		/>
	</valuation-layout>
</template>

<script>
import ValuationModelFactorList
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelFactorList';
import ValuationModelStepper
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/ValuationModelStepper';
import ValuationModelDescriptionNavigation
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelDescriptionNavigation';
import { mapState } from 'vuex';
import { __, append, ifElse, pathOr, propEq, reject, isEmpty, isNil } from 'ramda';
import ValuationLayout from '@/modules/job-evaluation/components/supplies/valuation-model/commons/ValuationLayout';
import { factorIsSelected, loadInformation } from '../../../../utils/valuation-model/factors';

export default {
	name: 'FactorsChoicePage',
	components: {
		ValuationLayout,
		ValuationModelFactorList,
		ValuationModelStepper,
		ValuationModelDescriptionNavigation,
	},
	mounted() {
		this.resetStore();
		this.$store.dispatch('jobEvaluation/getFactors')
			.then(() => {
				this.$store.dispatch('jobEvaluation/getJobValuationStatus');
			});
	},
	computed: {
		...mapState('jobEvaluation', {
			factorList: pathOr([], ['supplies', 'valuationModel', 'factorList']),
			selectedFactors: pathOr([], ['supplies', 'valuationModel', 'selectedFactors']),
			quantityFactor: pathOr([], ['mainData', 'config', 'stages', 0, 'details', 2, 'quantityFactor']),
			factorsWeight: pathOr({}, ['supplies', 'guidelineModel', 'informationJobEvaluation', 'factorsWeight']),
		}),
		hasValidFactors() {
			return this.selectedFactors.length >= this.quantityFactor;
		},
	},
	watch: {
		factorsWeight: {
			handler(newValue) {
				if (!isEmpty(newValue) && !isNil(newValue)) {
					const {
						selectedFactors,
						combinations,
						factorDegrees,
					} = loadInformation(newValue, this.factorList);
					this.$store.dispatch('jobEvaluation/setSelectedFactors', selectedFactors);
					this.$store.dispatch('jobEvaluation/setCombinations', combinations);
					this.$store.dispatch('jobEvaluation/setFactorDegrees', factorDegrees);
				}
			},
			immediate: true,
		},
	},
	methods: {
		resetStore() {
			this.$store.dispatch('jobEvaluation/resetValuationModelState', []);
		},
		onFactorClick(factor) {
			const newSelectedFactors = ifElse(
				factorItem => factorIsSelected(this.selectedFactors, factorItem),
				factorItem => reject(propEq('name', factorItem.name), this.selectedFactors),
				append(__, this.selectedFactors),
			)(factor);
			this.$store.dispatch('jobEvaluation/updateSelectedFactors', newSelectedFactors);
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/valuation-model/step-pages/FactorsChoicePage.vue